module.exports = __webpack_public_path__ + "666f41c974a0bccc89a609e35c6f6d97.png";